import { AccountService } from './../../core/services/AccountService';
import * as swal from 'sweetalert';
export class MigrationPageComponent implements ng.IComponentOptions {
  public controller: any = MigrationController;
  public template: string = /*html*/`
  <div class="container container-fluid">
    <breadcrumb tree="$ctrl.tree"></breadcrumb>
      <div class="wrapper row">
        <div class="col-md-3 sidebar">
          <div class="section-header">We've upgraded!</div>
          <div class="section-content">We've upgraded our user service to serve you better. Please key in password again to start the migration process</div>
        </div>
        <div class="col-md-9">
          <h2>Please review your profile</h2>
          <form name="resetForm" class="form-horizontal form-ckan">
          <div class="form-group">
            <label for="name" class="col-sm-5 control-label">Full Name</label>
            <div class="col-sm-7">
              <input type="text" class="form-control" ng-model="$ctrl.form.fullname" id="name" placeholder="Full Name">
            </div>
            </div>
            <div class="form-group">
            <label for="inputEmail" class="col-sm-5 control-label">Email</label>
            <div class="col-sm-7">
              <input type="email" class="form-control" ng-model="$ctrl.account.email" id="inputEmail" placeholder="Email" disabled>
            </div>
            </div>
            <div class="form-group">
            <label for="contact" class="col-sm-5 control-label">Contact No</label>
            <div class="col-sm-7">
            <input type="text" class="form-control" ng-model="$ctrl.form.contact" id="contact" placeholder="Contact No" required>
            </div>
            </div>
            <div class="form-group" ng-show="$ctrl.account.usertype == 'external'">
            <label for="userType" class="col-sm-5 control-label">Type of User</label>
            <div class="col-sm-7">
            <ui-select ng-model="$ctrl.form.category">
            <ui-select-match placeholder="Select a User Type">
            <span ng-bind="$select.selected"></span>
            </ui-select-match>
            <ui-select-choices repeat="item in ($ctrl.userType | filter: $select.search)">
            <span ng-bind="item"></span>
            </ui-select-choices>
            </ui-select>
            </div>
            </div>
            <div class="form-group" ng-show="$ctrl.account.usertype == 'external_org'">
            <label for="orgName" class="col-sm-5 control-label">Organisation Name</label>
            <div class="col-sm-7">
            <input type="text" class="form-control" id="orgName" ng-model="$ctrl.form.organization.name" placeholder="Organisation Name">
            </div>
            </div>
            <div class="form-group" ng-show="$sctrl.account.usertype == 'external_org'">
            <label for="orgType" class="col-sm-5 control-label">Type of Organisation</label>
            <div class="col-sm-7">
            <ui-select ng-model="$ctrl.form.organization.orgType">
            <ui-select-match placeholder="Select a Organisation Type">
            <span ng-bind="$select.selected"></span>
            </ui-select-match>
            <ui-select-choices repeat="item in ($ctrl.orgType | filter: $select.search)">
            <span ng-bind="item"></span>
            </ui-select-choices>
            </ui-select>
            </div>
            </div>
            <div class="form-group" ng-show="$ctrl.account.usertype == 'external'||$ctrl.account.usertype == 'external_org'">
            <label for="purpose" class="col-sm-5 control-label">Purpose</label>
            <div class="col-sm-7">
            <ui-select ng-model="$ctrl.form.purpose">
            <ui-select-match placeholder="Select a Purpose">
            <span ng-bind="$select.selected"></span>
            </ui-select-match>
            <ui-select-choices repeat="item in ($ctrl.purposes | filter: $select.search)">
            <span ng-bind="item"></span>
            </ui-select-choices>
            </ui-select>
            </div>
          </div>
          <div class="form-group">
            <label for="oldPass" class="col-sm-5 control-label">Current Password</label>
            <div class="col-sm-7">
              <input type="password" class="form-control" id="oldPass" ng-model="$ctrl.form.password" placeholder="Current Password" required>
            </div>
          </div>
          <div class="form-group">
            <label for="newPass2" class="col-sm-5 control-label">Repeat Password</label>
            <div class="col-sm-7">
              <input type="password" class="form-control" ng-model="$ctrl.form.password_verify" ng-blur="$ctrl.passCheck()" id="newPass2" placeholder="Repeat Password" required>
              <span class="text-warning" ng-show="$ctrl.error.password">Password not match</span>
            </div>
          </div>
        </form>
        <div class="control-panel">
          <button class="btn btn-primary pull-right" ng-click="resetForm.$valid && $ctrl.submit()">Submit</button>
        </div>
      </div>
    </div>
  </div>
  `
}

class MigrationController {
  public static $inject: Array<string> = ["AccountService", "$location", "$window", "$timeout"];
  public tree: object[]
  public form: any
  public error: any
  constructor(private account: AccountService, private $location: ng.ILocationService, $window: ng.IWindowService, private $timeout: ng.ITimeoutService) {
    this.tree = [
      {name: "User Migration", path:"#/migration", active: true}
    ];
    this.error = {
      password: false
    }
    this.account.$promise.then(d => {
      this.form = {
        fullname: d.fullname,
        contact: d.contact,
        category: d.category,
        organization: d.organization,
        purpose: d.purpose,
        password: '',
        password_verify: ''
      };
    })
  }

  public passCheck() {
    if(this.form.password && this.form.password_verify && this.form.password !== this.form.password_verify){
      this.error.password = true;
    }
    else {
      this.error.password = false;
    }
  }

  public submit() {
    if (this.form.password !== this.form.password_verify) {
      this.passCheck()
      return
    }
    else {
      this.account.migration(this.form)
      .then(() => {
        swal({
          title: "Success!",
          text: "Your Account has been migrated. You may continue using our service",
          type: "success"
        },
        d => {
          this.$timeout(() => {
            this.$location.url("/");
          })
        });
      })
      .catch(error => {
        if (error.status === '401') {
          swal("Authentication Failed!", "Please key in your correct password", "warning");
        }
        else {
          swal("Sorry!", "Something went wrong, please try again later", "warning");
        }
      })
    }
  }
}